import { Stack } from '@mui/material'

import { usePermissions } from '@/features/authorization/contexts/PermissionsContext'
import { SiteActivationOrderSettings } from '@/features/site/components/settings/activation_order/SiteActivationOrderSettings'
import { SiteNotificationPreferencesSettings } from '@/features/site/components/settings/notification_preferences/SiteNotificationPreferencesSettings'
import type { Site } from '@/features/site/types/site'

type SiteSettingsViewProps = {
  site: Site
}

export const SiteSettingsView = ({ site }: SiteSettingsViewProps) => {
  const { permissions } = usePermissions()
  return (
    <Stack spacing={2}>
      <SiteNotificationPreferencesSettings site={site} />
      {permissions.has('siteActivationOrderSettings') && <SiteActivationOrderSettings site={site} />}
    </Stack>
  )
}
